// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2ayF5","header":"MergedInvoice_header__12pym"};